import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Assignment } from '../../models/assignment.model';
import * as fromJobs from '../../reducers';
import { FormControl } from '@angular/forms';
import { Job } from '../../models/job.model';
import { UpdateJobAssignment } from '../../actions/jobs.actions';
import { Subscription } from 'rxjs';
import { UserState } from '../../../core/reducers/auth';

@Component({
  selector: 'mj-job-info-team-card',
  templateUrl: './job-info-team-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./job-info-team-card.component.scss'],
})
export class JobInfoTeamCardComponent implements OnInit, OnDestroy {
  defaultPicture =
    'https://test-mojobmedia.s3.amazonaws.com/img/default-profile.png';
  @Input() job: Job;
  @Input() jobAssignments: Assignment[];
  @Input() userState: UserState;
  @Output() onJobChanged: EventEmitter<Job> = new EventEmitter<Job>();
  poster = new FormControl();
  poster$: Subscription;

  constructor(private store: Store<fromJobs.State>) {}

  ngOnDestroy(): void {
    if (this.poster$) {
      this.poster$.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.poster.patchValue(this.job.poster_id || this.userState.currentUser.id);
    this.poster$ = this.poster.valueChanges.subscribe(val => {
      this.job.poster_id = val;
      this.onJobChanged.emit(this.job);
    });
  }

  updateAssignment(assignment: Assignment) {
    assignment.enabled = !assignment.enabled;
    this.store.dispatch(
      new UpdateJobAssignment({
        assignment: {
          ...assignment,
          enabled: assignment.enabled,
        },
      })
    );
  }
}
